/* import __COLOCATED_TEMPLATE__ from './attribute-descriptor-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();